import { render } from "./userAgreement.vue?vue&type=template&id=3581fde1&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=3581fde1&scoped=true&lang=css"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3581fde1"]])

export default __exports__